import type { Attachment } from "svelte/attachments";

const STEP: Readonly<Record<string, number>> = {
  ArrowRight: 1,
  ArrowDown: 1,
  ArrowLeft: -1,
  ArrowUp: -1,
};

const takeable = (answer: HTMLElement): boolean =>
  !answer.matches(":disabled") && answer.getAttribute("aria-disabled") !== "true";

export const choiceKeys =
  (answers: string, { picks }: { picks: boolean }): Attachment<HTMLElement> =>
  (node) => {
    const onkeydown = (event: KeyboardEvent): void => {
      const all = [...node.querySelectorAll<HTMLElement>(answers)].filter(takeable);
      const at = all.findIndex((answer) => answer === event.target);
      if (at < 0) return;
      const step = STEP[event.key];
      const to =
        event.key === "Home"
          ? 0
          : event.key === "End"
            ? all.length - 1
            : step === undefined
              ? null
              : (at + step + all.length) % all.length;
      if (to === null) return;
      event.preventDefault();
      const next = all[to];
      if (next === undefined) return;
      next.focus();
      if (picks && next !== event.target) next.click();
    };
    node.addEventListener("keydown", onkeydown);
    return () => node.removeEventListener("keydown", onkeydown);
  };
